export const GET_RESIDENT_SUMMARIES = "app/SUMMARY/GET_RESIDENT_SUMMARIES";
export const GET_RESIDENT_SUMMARIES_SUCCESS =
  "app/SUMMARY/GET_RESIDENT_SUMMARIES_SUCCESS";
export const GET_RESIDENT_SUMMARIES_FAILURE =
  "app/SUMMARY/GET_RESIDENT_SUMMARIES_FAILURE";

export const GET_RESIDENT_SUMMARY_DETAIL =
  "app/SUMMARY/GET_RESIDENT_SUMMARY_DETAIL";
export const GET_RESIDENT_SUMMARY_DETAIL_SUCCESS =
  "app/SUMMARY/GET_RESIDENT_SUMMARY_DETAIL_SUCCESS";
export const GET_RESIDENT_SUMMARY_DETAIL_FAILURE =
  "app/SUMMARY/GET_RESIDENT_SUMMARY_DETAIL_FAILURE";

export const SAVE_SUMMARY_ANNOTATION = "app/SUMMARY/SAVE_SUMMARY_ANNOTATION";
export const SAVE_SUMMARY_ANNOTATION_SUCCESS =
  "app/SUMMARY/SAVE_SUMMARY_ANNOTATION_SUCCESS";
export const SAVE_SUMMARY_ANNOTATION_FAILURE =
  "app/SUMMARY/SAVE_SUMMARY_ANNOTATION_FAILURE";
